import { DESCRIPTOR_PY_SEC, DESCRIPTOR_TYPE_PROP, DescriptorType, } from './Descriptors';
class DynamicElementBaseProp {
    constructor(key, parent, descriptor) {
        this.getLocale = () => { return this.parent.getLocale(); };
        this.key = key;
        this.data = parent.data;
        this.parent = parent;
        this.descriptor = descriptor;
    }
    get value() {
        return this.data[this.key];
    }
    set value(newValue) {
        if (newValue !== undefined) {
            this.data[this.key] = newValue;
        }
        else {
            delete this.data[this.key];
        }
        if (!(this instanceof DataNodePropComplex)) {
            const changedProp = {
                key: this.key,
                type: 'change',
                value: this.value,
            };
            this.parent._versionIncrement(changedProp);
        }
    }
    get displayValue() {
        return '';
    }
    get displayName() {
        let label = getLocalizedValue(this.descriptor.localizedDisplayNames, this.getLocale(), this.descriptor.displayName);
        if (!label)
            label = this.key;
        label = label.charAt(0).toUpperCase() + label.slice(1);
        return label;
    }
}
export const getLocalizedValue = (source, locale, defaultValue) => {
    const names = descriptorArrayToArray(source);
    if (locale !== undefined) {
        for (const name of names) {
            if (name.locale === null)
                continue;
            if (name.locale.substr(0, 2) === locale)
                return name.value;
        }
    }
    return defaultValue;
};
export const descriptorArrayToArray = (descriptorProp) => {
    let arr;
    if (descriptorProp[DESCRIPTOR_TYPE_PROP] === DescriptorType.pyAmfArrayCol) {
        arr = descriptorProp[DESCRIPTOR_PY_SEC];
    }
    else {
        arr = descriptorProp;
    }
    return arr;
};
export class DataNodePropText extends DynamicElementBaseProp {
    get displayValue() {
        return this.value || '';
    }
}
export class DataNodePropGeo extends DynamicElementBaseProp {
}
export class DataNodePropNumber extends DynamicElementBaseProp {
    get unit() {
        const un = this.descriptor.unit;
        if (un === null)
            return undefined;
        let res = un;
        if (this.parent.options && this.parent.options.translateUnit) {
            res = this.parent.options.translateUnit(un, { count: this.value });
        }
        return res;
    }
    get displayValue() {
        const value = this.value;
        if (value === undefined)
            return '';
        let resNumValue = value;
        const descriptor = this.descriptor;
        if (descriptor) {
            if (descriptor.precision !== undefined) {
                const pow = Math.pow(10, descriptor.precision);
                resNumValue = (Math.round(value * pow) / pow);
            }
            if (descriptor.kind === 'proportion') {
                resNumValue *= 100;
            }
        }
        let resValue = resNumValue.toString();
        if (this.unit)
            resValue += (this.unit === '%' ? '' : ' ') + this.unit;
        return resValue;
    }
    get minimum() {
        const dMin = this.descriptor.minimum;
        return dMin !== null ? dMin : undefined;
    }
    get maximum() {
        const dMax = this.descriptor.maximum;
        return dMax !== null ? dMax : undefined;
    }
}
export class DataNodePropCategory extends DynamicElementBaseProp {
    constructor() {
        super(...arguments);
        this.getOptions = () => {
            const options = [];
            if (this.descriptor.optionsList) {
                const descriptorOptions = descriptorArrayToArray(this.descriptor.optionsList);
                for (const descriptorOption of descriptorOptions) {
                    const label = getLocalizedValue(descriptorOption.localizedDisplayNames, this.getLocale(), descriptorOption.displayName);
                    options.push({ label, value: descriptorOption.value });
                }
            }
            return options;
        };
    }
    get displayValue() {
        if (this.value === undefined)
            return '';
        let resValue = '';
        const value = this.value;
        if (this.descriptor.optionsList) {
            const options = descriptorArrayToArray(this.descriptor.optionsList);
            for (const option of options) {
                if (option.value === value) {
                    resValue = getLocalizedValue(option.localizedDisplayNames, this.getLocale(), option.displayName);
                }
            }
        }
        return resValue;
    }
    get description() {
        const value = this.value;
        if (this.descriptor.optionsList) {
            const options = descriptorArrayToArray(this.descriptor.optionsList);
            for (const option of options) {
                if (option.value === value) {
                    return getLocalizedValue(option.localizedDescriptions, this.getLocale(), option.description);
                }
            }
        }
        return '';
    }
}
export class DataNodePropDynamicCategory extends DynamicElementBaseProp {
    constructor() {
        super(...arguments);
        this.getOptions = () => {
            let catOptions = [];
            const options = this.parent.options;
            if (options && options.getDynamicCategoryOptions) {
                catOptions = options.getDynamicCategoryOptions(this.descriptor.elementType);
            }
            return catOptions;
        };
    }
    get displayValue() {
        if (this.value === undefined)
            return '';
        let resValue = this.value || '';
        const catOptions = this.getOptions();
        for (const catOption of catOptions) {
            if (catOption.value === this.value)
                resValue = catOption.label;
        }
        return resValue;
    }
}
export class DataNodePropDate extends DynamicElementBaseProp {
    get displayValue() {
        var _a;
        const options = this.parent.options;
        if (this.value === undefined)
            return '';
        if ((_a = options) === null || _a === void 0 ? void 0 : _a.formatDate) {
            return options.formatDate(this.value);
        }
        return `${this.value.year}-${this.value.month + 1}-${this.value.date}`;
    }
}
export class DataNodePropComplex extends DynamicElementBaseProp {
    constructor(key, parent, descriptor) {
        var _a;
        super(key, parent, descriptor);
        this._nodes = [];
        this.addElement = (elementData) => {
            if (!this.value)
                this.value = [];
            this.value.push(elementData);
            const newElement = new DataNode(elementData, this.descriptor, this.parent, this.parent.options);
            this.nodes.push(newElement);
            this.parent._versionIncrement({
                key: this.key,
                type: 'add',
                item: elementData,
            });
        };
        this.deleteElement = (elementId) => {
            const node = this.nodes.find(n => n.id === elementId);
            if (!node)
                return;
            this.nodes.splice(this.nodes.indexOf(node), 1);
            if (this.value) {
                const valueInd = this.value.indexOf(node.data);
                if (valueInd !== -1)
                    this.value.splice(valueInd, 1);
            }
            this.parent._versionIncrement({
                key: this.key,
                type: 'delete',
                id: elementId,
            });
        };
        this.getElement = (id) => {
            for (const element of this.nodes) {
                if (element.id.toString() === id)
                    return element;
            }
            return undefined;
        };
        if ((_a = parent.options) === null || _a === void 0 ? void 0 : _a.arrayFactory) {
            this._nodes = parent.options.arrayFactory();
        }
        if (this.value) {
            for (const elementData of this.value) {
                this.nodes.push(new DataNode(elementData, descriptor, parent, parent.options));
            }
        }
    }
    get nodes() {
        return this._nodes;
    }
}
export class DataNode {
    constructor(data, descriptor, parent, options) {
        var _a;
        this.props = [];
        this.getLocale = () => {
            if (this.options && this.options.getLocale)
                return this.options.getLocale();
            return undefined;
        };
        this._versionModel = { version: 0 };
        this._versionIncrement = (changedKey) => {
            var _a;
            const changedProps = (_a = this.data.___changeProps, (_a !== null && _a !== void 0 ? _a : {}));
            if (!this.data.___changeProps)
                this.data.___changeProps = changedProps;
            const newVersion = this._versionModel.version + 1;
            changedProps.version = newVersion;
            if (changedKey) {
                if (!changedProps.changedKeys)
                    changedProps.changedKeys = [];
                changedProps.changedKeys.push(changedKey);
            }
            this._versionModel.version = newVersion;
        };
        this.commit = () => {
            delete this.data.___changeProps;
            for (const prop of this.props) {
                if (prop instanceof DataNodePropComplex) {
                    for (const propElement of prop.nodes) {
                        propElement.commit();
                    }
                }
            }
            this._versionModel.version = 0;
        };
        this.getProp = (key, type) => {
            for (const prop of this.props) {
                if (prop.key === key && prop.descriptor[DESCRIPTOR_TYPE_PROP] === type)
                    return prop;
            }
            return undefined;
        };
        this.getValue = (key, type) => {
            const prop = this.getProp(key, type);
            if (prop)
                return prop.value;
            return undefined;
        };
        this.setValue = (key, type, value) => {
            const prop = this.getProp(key, type);
            if (prop)
                prop.value = value;
        };
        this._getListPropDisplayValue = (listProps, listPropsElementGetter) => {
            let value = undefined;
            if (!this.descriptor)
                return value;
            for (const listProp of listProps) {
                if (listProp.descriptorName === this.descriptor.name) {
                    const propElement = listPropsElementGetter(listProp);
                    if (!propElement)
                        return undefined;
                    const prop = this.getProp(propElement.key, propElement.type || DescriptorType.text);
                    if (!prop)
                        return undefined;
                    value = prop.displayValue;
                }
            }
            return value;
        };
        this.data = data;
        if (options) {
            const { versionModelFactory, ignoredChangedKeys } = options;
            if (versionModelFactory)
                this._versionModel = versionModelFactory();
        }
        if ((_a = data.___changeProps) === null || _a === void 0 ? void 0 : _a.version)
            this._versionModel.version = data.___changeProps.version;
        this.options = options;
        this.descriptor = descriptor;
        this.parent = parent;
        if (descriptor.properties) {
            const propArray = descriptorArrayToArray(descriptor.properties);
            for (const descriptorProperty of propArray) {
                const type = descriptorProperty[DESCRIPTOR_TYPE_PROP];
                let newProp;
                const dataKey = descriptorProperty.name;
                switch (type) {
                    case DescriptorType.text:
                        newProp =
                            new DataNodePropText(dataKey, this, descriptorProperty);
                        break;
                    case DescriptorType.dynamicCategory:
                        newProp =
                            new DataNodePropDynamicCategory(dataKey, this, descriptorProperty);
                        break;
                    case DescriptorType.complex:
                        newProp =
                            new DataNodePropComplex(dataKey, this, descriptorProperty);
                        break;
                    case DescriptorType.numeric:
                        newProp =
                            new DataNodePropNumber(dataKey, this, descriptorProperty);
                        break;
                    case DescriptorType.category:
                        newProp =
                            new DataNodePropCategory(dataKey, this, descriptorProperty);
                        break;
                    case DescriptorType.date:
                        newProp =
                            new DataNodePropDate(dataKey, this, descriptorProperty);
                        break;
                    case DescriptorType.geo:
                        newProp =
                            new DataNodePropGeo(dataKey, this, descriptorProperty);
                        break;
                }
                if (newProp) {
                    this.props.push(newProp);
                }
            }
        }
    }
    get id() {
        var _a, _b, _c;
        const uid = (_c = (_a = this.options) === null || _a === void 0 ? void 0 : (_b = _a).getId) === null || _c === void 0 ? void 0 : _c.call(_b, this.data);
        return (uid !== null && uid !== void 0 ? uid : this.data.uid.toString());
    }
    get propsElements() {
        return this.props.filter(prop => prop instanceof DataNodePropComplex);
    }
    get version() {
        let sum = this._versionModel.version;
        for (const prop of this.props) {
            if (prop instanceof DataNodePropComplex) {
                for (const propElement of prop.nodes) {
                    sum += propElement.version;
                }
            }
        }
        return sum;
    }
    get changedData() {
        var _a, _b, _c;
        let changedData = [];
        if (this.version > 0) {
            for (const prop of this.props) {
                if ((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.ignoredChangedKeys) === null || _b === void 0 ? void 0 : _b.includes(prop.key))
                    continue;
                if (prop instanceof DataNodePropComplex) {
                    for (const propElement of prop.nodes) {
                        changedData = changedData.concat(propElement.changedData);
                    }
                }
            }
            const keys = (_c = this.data.___changeProps) === null || _c === void 0 ? void 0 : _c.changedKeys;
            if (keys) {
                changedData.push({
                    position: this.nodeTreePosition,
                    changedKeys: keys,
                    descriptor: this.descriptor,
                });
            }
        }
        return changedData;
    }
    get nodeTreePosition() {
        let res = [];
        let parentKey = undefined;
        if (this.parent) {
            for (const parentProp of this.parent.props) {
                if (parentProp instanceof DataNodePropComplex) {
                    for (const propElement of parentProp.nodes) {
                        if (propElement === this) {
                            parentKey = parentProp.key;
                            break;
                        }
                    }
                }
                if (parentKey)
                    break;
            }
        }
        const pos = { id: this.id };
        if (parentKey) {
            pos.parentKey = parentKey;
        }
        res.push(pos);
        if (this.parent) {
            res = this.parent.nodeTreePosition.concat(res);
        }
        return res;
    }
    get listPrimaryPropDisplayValue() {
        var _a, _b;
        return this._getListPropDisplayValue((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.listProps, (_b !== null && _b !== void 0 ? _b : [])), listProp => listProp.primaryProp);
    }
    get listSecondaryPropDisplayValue() {
        var _a, _b;
        return this._getListPropDisplayValue((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.listProps, (_b !== null && _b !== void 0 ? _b : [])), listProp => listProp.secondaryProp);
    }
}
